<template>
    <InformeCard title="Venta diaria" style="height: 411px">
        <template slot="actions">
            <Button :href="url_descarga_excel" download class="button small-button" icon="fa fa-download mr-1">Descargar</Button>
        </template>
        <ContentOrLoading>
            <GChart
                v-if="chartData"
                type="LineChart"
                :data="chartData"
                :options="chartOptions"
            />
        </ContentOrLoading>
    </InformeCard>
</template>

<script>
    import ContentOrLoading from "../../components/ContentOrLoading";
    import InformeCard from "../InformeCard";

    export default {
        props: ['event_id', 'taquillero_id'],
        data() {
            return {
                chartData: null,
                chartOptions: {
                    height: 250,
                    chartArea:{width:'100%'}
                }
            }
        },
        created() {
            this.getVentaDiaria();
        },
        computed: {
            url_descarga_excel() {
                return this.config.API_BASE + '/eventos/' + this.event_id + '/venta-diaria-excel?api_key=' + localStorage.getItem('token') + '&tid=' + localStorage.getItem('hash_teatro');
            }
        },
        watch: {
            taquillero_id() {
                this.getVentaDiaria();
            }
        },
        methods: {
            getVentaDiaria : function() {
                const params = {
                    filters: {
                        taquillero_id: this.taquillero_id
                    },
                    evento_id : this.event_id,
                };

                this.$store.dispatch(this.config.getVuexAlias('back.events.informe.venta-diaria'), params).then(res => {
                    var valores = [];

                    valores.push(['Fecha', 'Ventas']);

                    for(var i in res.data.data) {
                        valores.push([res.data.data[i].fecha, res.data.data[i].total]);
                    }

                    this.chartData = valores;
                });
            }
        },
        components: {
            InformeCard,
            ContentOrLoading
        }
    }
</script>